import { ButtonLanding } from "../../../components/Buttons";
import useUserLogin from "../hooks/useUserLogin";

const guestCredentials = {
  email: "guest@gmail.com",
  password: "physiotrack.guest",
};

function LoginGuest() {
  const [loginHandler, loading, error] = useUserLogin();

  const loginAsGuest = () => {
    loginHandler(guestCredentials.email, guestCredentials.password);
    // emailRef.current.value = guestCredentials.email;
    // passwordRef.current.value = guestCredentials.password;
    // setLabelShrink(true);
  };

  return (
    <ButtonLanding
      variant={2}
      name="App demo"
      onClick={loginAsGuest}
      loading={loading}
    />
  );
}

export default LoginGuest;
